import { Theme } from 'config';

const styles = (theme: Theme) => ({
  container: {
    backgroundColor: '#fff',
    padding: '.625rem 1.25rem !important',
    borderRadius: '.25rem !important',
    boxShadow: '0 .125rem .375rem 0 rgba(0,0,0,0.05)',
    margin: '.625em -1em 3rem !important',
  },
  grid: {
    position: 'relative',
  },
  statsRow: {
    display: 'flex !important',
    justifyContent: 'space-around !important',
    padding: '0 !important',
  },
  headerBlock: {
    background: '#fff !important',
    padding: '1rem !important',
  },
  header: {
    color: `${theme.darkGray} !important`,
  },
  loading: {
    '&&': {
      margin: '0 -1rem !important',
    },
  },
  label: {
    color: '#999 !important',
    fontSize: '.75rem !important',
    fontWeight: 'bold !important',
    letterSpacing: '.125rem !important',
    textTransform: 'uppercase !important',
    textAlign: 'left !important',
  },
  value: {
    textAlign: 'right !important',

    '& > span': {
      fontWeight: '500 !important',
    },
  },
  '@global .ui.statistics': {
    margin: '0 !important',
  },
  '@global .ui.statistics .statistic > .value': {
    color: '#683caf !important',
    fontSize: '1.875rem !important',
    marginTop: '.625rem !important',
  },
});

export default styles;
